var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:'cursor-pointer flag-icon flag-' + _vm.component + ' flag-' + _vm.lang,attrs:{"href":"javascript:return false","alt":_vm.lang},on:{"click":function($event){return _vm.setLanguage()}}})}
var staticRenderFns = []

export { render, staticRenderFns }